import React, {FC} from "react";
import {useSelector} from "../store";
import useTripPackages from "../hooks/use-trip-packages";
import {LiveabaordPackage, ResortPackage, DiveShopPackage} from "../types/package";
import {Box} from "@mui/material";
import {LiveaboardRow, ResortRow, DiveShopRow} from "./pricing/package-rows";

type Props = {
    period: string;
}

export const PricingList = ({period}: Props) => {

    const {selectedTripId} = useSelector((state) => state.userSession);

    const {tripPackages} = useTripPackages(selectedTripId)

    const elements = tripPackages?.periods[period]?.map((tripPackage, idx) => {
        switch (tripPackage.type) {
            case "liveaboard":
                return <LiveaboardRow key={idx} pack={tripPackage as LiveabaordPackage}/>
            case "resort":
                return <ResortRow key={idx} pack={tripPackage as ResortPackage}/>
            case "diveshop":
                return <DiveShopRow key={idx} pack={tripPackage as DiveShopPackage}/>
            case "conservation":
                return <DiveShopRow key={idx} pack={tripPackage as DiveShopPackage}/>
        }
    })

    return <Box
        sx={{
            py: 3,
            px: {
                xs: 0,
                sm: 1,
                md: 2,
                lg: 3
            }
        }}>{elements}</Box>;
}

